require('../../legacy_modules/web_2018/frontend/web_2018')
window.lodash = require 'lodash'
